import { useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetDescription, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Logo } from "@/components/brand/Logo";
import { TextSizeToggle } from "@/components/layout/TextSizeToggle";
import { NAV, useNavGo } from "@/components/layout/nav";

export const MobileMenu = () => {
  const [open, setOpen] = useState(false);
  const go = useNavGo();

  const handle = (item) => {
    setOpen(false);
    setTimeout(() => go(item), 250);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button type="button" aria-label="Apri il menu" data-testid="mobile-menu-button" className="grid h-12 w-12 place-items-center rounded-full border border-navy/20 text-navy lg:hidden">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" data-lenis-prevent data-testid="mobile-menu" className="flex w-[88vw] flex-col border-r-copper/20 bg-ivory p-8 sm:max-w-md">
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <SheetDescription className="sr-only">Navigazione del sito Perfero</SheetDescription>
        <Logo />
        <nav className="mt-14 flex flex-col gap-6" aria-label="Menu mobile">
          {NAV.map((item) => (
            <button key={item.id} type="button" onClick={() => handle(item)} data-testid={`mobile-nav-${item.id}`} className="text-left font-display text-4xl text-navy">
              {item.label}
            </button>
          ))}
        </nav>
        <div className="mt-auto space-y-3">
          <p className="eyebrow">Dimensione del testo</p>
          <TextSizeToggle />
        </div>
      </SheetContent>
    </Sheet>
  );
};
